// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* RobiTest 2.0 shared page primitives */

.rt-page {
  display: flex;
  flex-direction: column;
  gap: 10px;
  min-width: 0;
}

.rt-page-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  margin: 0;
}

.rt-page-header__left {
  min-width: 0;
  flex: 1 1;
}

.rt-page-header__eyebrow {
  margin: 0 0 4px;
  font-size: 11px;
  font-weight: 650;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--rt-text-muted);
}

.rt-page-header__title {
  margin: 0;
  font-size: 1.35rem;
  font-weight: 700;
  letter-spacing: -0.02em;
  color: var(--rt-text);
  line-height: 1.25;
}

.rt-page-header__title-row {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}

.rt-page-header__back {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 32px;
  padding: 0 12px;
  border: 1px solid var(--rt-border);
  border-radius: var(--rt-radius-md, 8px);
  background: var(--rt-surface);
  color: var(--rt-text);
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
  line-height: 1;
  cursor: pointer;
  transition: background 150ms ease, border-color 150ms ease;
}

.rt-page-header__back:hover {
  background: var(--surface-hover, var(--rt-surface));
  border-color: var(--rt-primary);
  color: var(--rt-primary);
}

.rt-page-header__back:focus-visible {
  outline: none;
  box-shadow: var(--shadow-focus, 0 0 0 3px rgba(37, 99, 235, 0.35));
}

.rt-page-header__desc {
  margin: 4px 0 0;
  font-size: var(--rt-text-sm);
  color: var(--rt-text-muted);
  max-width: 64ch;
}

.rt-page-header__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
}

.rt-section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 10px;
}

.rt-section-header__title {
  margin: 0;
  font-size: var(--rt-text-sm);
  font-weight: 650;
}

.rt-breadcrumbs {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  margin-bottom: 2px;
  font-size: var(--rt-text-xs);
  color: var(--rt-text-muted);
}

.rt-breadcrumbs__sep {
  opacity: 0.5;
}

.rt-breadcrumbs__link {
  background: none;
  border: none;
  padding: 0;
  color: var(--rt-primary);
  font: inherit;
  cursor: pointer;
}

.rt-breadcrumbs__link:hover {
  text-decoration: underline;
}

.rt-breadcrumbs__current {
  color: var(--rt-text-secondary);
  font-weight: 600;
}

.rt-filter-bar {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
  padding: 10px 12px;
  background: var(--rt-surface);
  border: 1px solid var(--rt-border);
  border-radius: var(--rt-radius-lg);
}

.rt-search {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 32px;
  min-width: 220px;
  padding: 0 10px;
  border: 1px solid var(--rt-border);
  border-radius: var(--rt-radius-md);
  background: var(--rt-bg);
}

.rt-search input {
  flex: 1 1;
  border: none;
  background: transparent;
  outline: none;
  font: inherit;
  font-size: var(--rt-text-sm);
  color: var(--rt-text);
  min-width: 0;
}

.rt-tabs {
  display: flex;
  gap: 2px;
  border-bottom: 1px solid var(--rt-border);
  overflow-x: auto;
  overflow-y: hidden;
  scrollbar-width: none;
}

.rt-tabs::-webkit-scrollbar {
  display: none;
}

.rt-tabs__tab {
  appearance: none;
  border: none;
  background: transparent;
  padding: 10px 14px;
  font: inherit;
  font-size: var(--rt-text-sm);
  font-weight: 550;
  color: var(--rt-text-muted);
  cursor: pointer;
  border-bottom: 2px solid transparent;
  white-space: nowrap;
}

.rt-tabs__tab:hover {
  color: var(--rt-text);
}

.rt-tabs__tab--active {
  color: var(--rt-primary);
  border-bottom-color: var(--rt-primary);
  font-weight: 650;
}

.rt-data-table-wrap {
  background: var(--rt-surface);
  border: 1px solid var(--rt-border);
  border-radius: var(--rt-radius-lg);
  overflow: auto;
}

.rt-data-table {
  width: 100%;
  border-collapse: collapse;
  font-size: var(--rt-text-sm);
}

.rt-data-table th {
  text-align: left;
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--rt-text-muted);
  font-weight: 650;
  padding: 10px 12px;
  border-bottom: 1px solid var(--rt-border);
  background: var(--rt-surface-hover);
  position: sticky;
  top: 0;
  z-index: 1;
  white-space: nowrap;
}

.rt-data-table td {
  padding: 10px 12px;
  border-bottom: 1px solid var(--rt-border-subtle);
  vertical-align: middle;
}

.rt-data-table tr:hover td {
  background: var(--rt-surface-hover);
}

.rt-data-table tr.rt-data-table__row--clickable {
  cursor: pointer;
}

.rt-bulk-bar {
  position: sticky;
  bottom: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 14px;
  background: #0f172a;
  color: #fff;
  border: 1px solid transparent;
  border-radius: var(--rt-radius-lg);
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.2);
  z-index: 20;
}

.rt-bulk-bar__actions {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.rt-bulk-bar > span {
  font-weight: 600;
}

.rt-bulk-bar .rt-btn--secondary {
  background: transparent;
  color: #fff;
  border-color: rgba(255, 255, 255, 0.35);
}

.rt-bulk-bar .rt-btn--secondary:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.1);
}

[data-theme='dark'] .rt-bulk-bar {
  background: var(--surface-raised, #0f1b2e);
  color: var(--text-primary);
  border-color: color-mix(in srgb, var(--primary) 55%, transparent);
  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.45);
}

[data-theme='dark'] .rt-bulk-bar .rt-btn--secondary {
  color: var(--text-primary);
  border-color: var(--border-strong, var(--border));
}

[data-theme='dark'] .rt-bulk-bar .rt-btn--secondary:hover:not(:disabled) {
  background: var(--surface-hover);
}

.rt-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 48px 20px;
  text-align: center;
  background: var(--rt-surface);
  border: 1px dashed var(--rt-border);
  border-radius: var(--rt-radius-lg);
  color: var(--rt-text-muted);
}

.rt-state__title {
  margin: 0;
  font-size: var(--rt-text-base);
  font-weight: 650;
  color: var(--rt-text);
}

.rt-state__desc {
  margin: 0;
  font-size: var(--rt-text-sm);
  max-width: 42ch;
}

.rt-drawer-overlay {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.35);
  z-index: 80;
  display: flex;
  justify-content: flex-end;
}

.rt-drawer {
  width: min(480px, 100vw);
  height: 100%;
  background: var(--rt-surface);
  border-left: 1px solid var(--rt-border);
  display: flex;
  flex-direction: column;
  box-shadow: -12px 0 40px rgba(15, 23, 42, 0.12);
}

.rt-drawer--wide {
  width: min(640px, 100vw);
}

.rt-drawer__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: 16px 18px;
  border-bottom: 1px solid var(--rt-border);
}

.rt-drawer__title {
  margin: 0;
  font-size: 1rem;
  font-weight: 700;
}

.rt-drawer__body {
  flex: 1 1;
  overflow: auto;
  padding: 16px 18px;
}

.rt-drawer__footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 12px 18px;
  border-top: 1px solid var(--rt-border);
  background: var(--rt-bg);
}

.rt-dialog-overlay {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.4);
  z-index: 90;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.rt-dialog {
  width: min(420px, 100%);
  background: var(--rt-surface);
  border: 1px solid var(--rt-border);
  border-radius: var(--rt-radius-lg);
  box-shadow: 0 20px 50px rgba(15, 23, 42, 0.2);
  padding: 18px;
}

.rt-dialog__title {
  margin: 0 0 8px;
  font-size: 1rem;
  font-weight: 700;
}

.rt-dialog__body {
  margin: 0 0 16px;
  font-size: var(--rt-text-sm);
  color: var(--rt-text-secondary);
}

.rt-dialog__actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

.rt-metric-card {
  background: var(--rt-surface);
  border: 1px solid var(--rt-border);
  border-radius: var(--rt-radius-lg);
  padding: 12px 14px;
}

.rt-metric-card__label {
  font-size: 0.6875rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--rt-text-muted);
}

.rt-metric-card__value {
  font-size: 1.625rem;
  font-weight: 750;
  letter-spacing: -0.03em;
  font-variant-numeric: tabular-nums;
}

.rt-metric-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  gap: 12px;
}

.rt-hub-layout {
  display: grid;
  grid-template-columns: 200px 1fr;
  gap: 14px;
  align-items: start;
}

.rt-hub-nav {
  background: var(--rt-surface);
  border: 1px solid var(--rt-border);
  border-radius: var(--rt-radius-lg);
  padding: 8px;
  position: sticky;
  top: 8px;
}

.rt-hub-nav__item {
  display: flex;
  width: 100%;
  align-items: center;
  gap: 8px;
  padding: 8px 10px;
  border: none;
  border-radius: var(--rt-radius-md);
  background: transparent;
  color: var(--rt-text-secondary);
  font: inherit;
  font-size: var(--rt-text-sm);
  font-weight: 550;
  text-align: left;
  cursor: pointer;
}

.rt-hub-nav__item:hover {
  background: var(--rt-bg);
  color: var(--rt-text);
}

.rt-hub-nav__item--active {
  background: var(--rt-primary-subtle);
  color: var(--rt-primary);
  font-weight: 650;
}

.rt-hub-content {
  min-width: 0;
}

/* Settings hub: single section header + content panel (no nested duplicate titles) */
.rt-settings-layout {
  align-items: start;
}

.rt-settings-nav-group {
  margin-bottom: 12px;
}

.rt-settings-nav-group:last-child {
  margin-bottom: 0;
}

.rt-settings-nav-group__label {
  padding: 4px 10px;
}

.rt-settings-section-header {
  margin-bottom: 12px;
}

.rt-settings-section-header__title {
  margin: 0 0 4px;
  font-size: 1.05rem;
  font-weight: 650;
  color: var(--rt-text);
  line-height: 1.3;
}

.rt-settings-section-header__description {
  margin: 0;
  font-size: var(--rt-text-sm, 0.875rem);
  color: var(--rt-text-secondary);
  line-height: 1.45;
}

.rt-settings-panel {
  background: var(--rt-surface);
  border: 1px solid var(--rt-border);
  border-radius: var(--rt-radius-lg);
  padding: 1.25rem 1.35rem;
  min-width: 0;
}

.rt-settings-panel .settings-section {
  margin-bottom: 0;
}

.rt-settings-panel .settings-section-title {
  font-size: 1.35rem;
  font-weight: 700;
  letter-spacing: -0.02em;
  line-height: 1.25;
  margin-bottom: 0.35rem;
  padding-bottom: 0;
  border-bottom: none;
}

.rt-settings-panel .settings-section-intro {
  margin-bottom: 1.15rem;
  padding-bottom: 0.85rem;
  border-bottom: 1px solid var(--rt-border-subtle, var(--rt-border));
}

.rt-settings-panel .settings-section-intro .settings-subtitle {
  margin-bottom: 0 !important;
}

.rt-legacy-embed {
  /* Soften legacy page chrome when nested in AppShell */
}

.rt-legacy-embed .settings-container,
.rt-legacy-embed .test-cases-overview-container,
.rt-legacy-embed .test-suites-container,
.rt-legacy-embed .test-plans-container,
.rt-legacy-embed .reports-container,
.rt-legacy-embed .requirement-upload-page,
.rt-legacy-embed .jira-items-container {
  padding: 0 !important;
  margin: 0 !important;
  max-width: none !important;
  background: transparent !important;
  box-shadow: none !important;
}

.rt-detail-layout {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 280px;
  gap: 14px;
  align-items: start;
}

.rt-detail-main,
.rt-detail-side {
  background: var(--rt-surface);
  border: 1px solid var(--rt-border);
  border-radius: var(--rt-radius-lg);
  min-width: 0;
}

.rt-detail-main__body {
  padding: 16px;
}

.rt-detail-side {
  padding: 14px;
  position: sticky;
  top: 8px;
}

.rt-detail-meta {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.rt-detail-meta__row {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.rt-detail-meta__label {
  font-size: 10px;
  font-weight: 650;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--rt-text-muted);
}

.rt-detail-meta__value {
  font-size: var(--rt-text-sm);
  color: var(--rt-text);
  word-break: break-word;
}

@media (max-width: 960px) {
  .rt-hub-layout,
  .rt-detail-layout {
    grid-template-columns: 1fr;
  }

  .rt-detail-side {
    position: static;
  }

  .rt-hub-nav {
    position: static;
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
  }
}

.rt-page-header--slim {
  margin-bottom: 4px;
  padding-bottom: 8px;
  border-bottom: 1px solid var(--rt-border-subtle);
}

.rt-page--compact .rt-page-header__title {
  font-size: 1.15rem;
}

/* Hide nested legacy page titles when wrapped by RT2 PageScaffold */
.rt-legacy-embed .report-title,
.rt-legacy-embed .report-subtitle,
.rt-legacy-embed .settings-header,
.rt-legacy-embed .settings-title,
.rt-legacy-embed .dashboard-welcome,
.rt-legacy-embed .projects-title,
.rt-legacy-embed .projects-subtitle,
.rt-legacy-embed .epics-stories-header h1,
.rt-legacy-embed .requirement-upload-page > h1 {
  display: none !important;
}

.rt-entity-chrome-hidden {
  display: none !important;
}

/* Global RT2 modal skin — highlighted header wash */
.modal-header,
.test-execution-modal .modal-header,
.create-test-suite-modal .modal-header,
.schedule-modal .modal-header,
.sprint-modal .modal-header,
.workspace-modal .modal-header,
.rt-modal__header {
  background-color: #eff6ff !important;
  background-image:
    linear-gradient(
      135deg,
      rgba(37, 99, 235, 0.14) 0%,
      rgba(59, 130, 246, 0.1) 48%,
      rgba(96, 165, 250, 0.08) 100%
    ) !important;
  color: #1e3a8a !important;
  border-bottom: 1px solid rgba(37, 99, 235, 0.22);
  border-radius: var(--rt-radius-lg, 16px) var(--rt-radius-lg, 16px) 0 0;
  padding: 16px 20px;
}

.modal-header h2,
.modal-header h3,
.modal-header .modal-title,
.test-execution-modal .modal-header h2,
.schedule-modal .modal-header h2,
.sprint-modal .modal-header h2,
.workspace-modal .modal-header h2,
.rt-modal__header h2,
.rt-modal__title {
  color: #1e3a8a !important;
  font-size: 1.125rem;
  font-weight: 700;
  letter-spacing: -0.01em;
  margin: 0;
}

.modal-header .modal-close,
.modal-header .modal-close-btn,
.modal-header .close-button,
.modal-header button,
.rt-modal__close {
  color: #3b82f6 !important;
}

.modal-container,
.test-execution-modal,
.create-test-suite-modal,
.schedule-modal,
.sprint-modal,
.workspace-modal {
  border: 1px solid var(--rt-border, var(--border));
  border-radius: var(--rt-radius-lg, 16px);
  box-shadow: var(--modal-shadow, 0 24px 48px rgba(15, 23, 42, 0.2));
}

.modal-footer,
.test-execution-modal .modal-footer,
.schedule-modal .modal-footer,
.workspace-modal .modal-footer {
  background: transparent !important;
  border-top: 1px solid var(--rt-border, var(--border));
}

.rt-plan-as-page {
  position: static !important;
  inset: auto !important;
  background: transparent !important;
  padding: 0 !important;
  display: block !important;
  z-index: auto !important;
}

.rt-plan-as-page > div {
  width: 100% !important;
  height: auto !important;
  max-height: none !important;
  box-shadow: none !important;
  border: 1px solid var(--rt-border);
  border-radius: var(--rt-radius-lg);
}
`, "",{"version":3,"sources":["webpack://./src/styles/rt2-primitives.css"],"names":[],"mappings":"AAAA,wCAAwC;;AAExC;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,SAAO;AACT;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,kCAAkC;EAClC,uCAAuC;EACvC,6BAA6B;EAC7B,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,0DAA0D;AAC5D;;AAEA;EACE,mDAAmD;EACnD,+BAA+B;EAC/B,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,kEAAkE;AACpE;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,wBAAwB;EACxB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;EACnB,kBAAkB;EAClB,6BAA6B;EAC7B,kCAAkC;EAClC,kCAAkC;AACpC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,kCAAkC;EAClC,kCAAkC;EAClC,wBAAwB;AAC1B;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,aAAa;EACb,4BAA4B;EAC5B,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,yCAAyC;EACzC,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,4BAA4B;EAC5B,gBAAgB;EAChB,2BAA2B;EAC3B,eAAe;EACf,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;EACxB,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,kCAAkC;EAClC,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,2BAA2B;EAC3B,gBAAgB;EAChB,kBAAkB;EAClB,yCAAyC;EACzC,mCAAmC;EACnC,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gDAAgD;EAChD,sBAAsB;AACxB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,6BAA6B;EAC7B,kCAAkC;EAClC,4CAA4C;EAC5C,WAAW;AACb;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,WAAW;EACX,uCAAuC;AACzC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,0CAA0C;EAC1C,0BAA0B;EAC1B,iEAAiE;EACjE,2CAA2C;AAC7C;;AAEA;EACE,0BAA0B;EAC1B,iDAAiD;AACnD;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,kBAAkB;EAClB,6BAA6B;EAC7B,mCAAmC;EACnC,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,8BAA8B;EAC9B,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,kCAAkC;EAClC,WAAW;EACX,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,YAAY;EACZ,6BAA6B;EAC7B,uCAAuC;EACvC,aAAa;EACb,sBAAsB;EACtB,+CAA+C;AACjD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;EACR,kBAAkB;EAClB,sCAAsC;EACtC,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,iCAAiC;EACjC,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,kCAAkC;EAClC,kCAAkC;EAClC,6CAA6C;EAC7C,aAAa;AACf;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;AACV;;AAEA;EACE,6BAA6B;EAC7B,kCAAkC;EAClC,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,kCAAkC;EAClC,kCAAkC;EAClC,YAAY;EACZ,gBAAgB;EAChB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,YAAY;EACZ,kCAAkC;EAClC,uBAAuB;EACvB,+BAA+B;EAC/B,aAAa;EACb,4BAA4B;EAC5B,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA,qFAAqF;AACrF;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,sCAAsC;EACtC,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,kCAAkC;EAClC,kCAAkC;EAClC,wBAAwB;EACxB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,kEAAkE;AACpE;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,sDAAsD;AACxD;;AAEA;;;;;;;EAOE,qBAAqB;EACrB,oBAAoB;EACpB,0BAA0B;EAC1B,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,SAAS;EACT,kBAAkB;AACpB;;AAEA;;EAEE,6BAA6B;EAC7B,kCAAkC;EAClC,kCAAkC;EAClC,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;EAC5B,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,aAAa;IACb,eAAe;IACf,QAAQ;EACV;AACF;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gDAAgD;AAClD;;AAEA;EACE,kBAAkB;AACpB;;AAEA,oEAAoE;AACpE;;;;;;;;;EASE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,oDAAoD;AACpD;;;;;;;EAOE,oCAAoC;EACpC;;;;;;gBAMc;EACd,yBAAyB;EACzB,gDAAgD;EAChD,sEAAsE;EACtE,kBAAkB;AACpB;;AAEA;;;;;;;;;EASE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,SAAS;AACX;;AAEA;;;;;EAKE,yBAAyB;AAC3B;;AAEA;;;;;;EAME,iDAAiD;EACjD,wCAAwC;EACxC,kEAAkE;AACpE;;AAEA;;;;EAIE,kCAAkC;EAClC,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,sBAAsB;EACtB,kCAAkC;EAClC,qBAAqB;EACrB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;EAC3B,kCAAkC;EAClC,kCAAkC;AACpC","sourcesContent":["/* RobiTest 2.0 shared page primitives */\n\n.rt-page {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  min-width: 0;\n}\n\n.rt-page-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  flex-wrap: wrap;\n  margin: 0;\n}\n\n.rt-page-header__left {\n  min-width: 0;\n  flex: 1;\n}\n\n.rt-page-header__eyebrow {\n  margin: 0 0 4px;\n  font-size: 11px;\n  font-weight: 650;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: var(--rt-text-muted);\n}\n\n.rt-page-header__title {\n  margin: 0;\n  font-size: 1.35rem;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  color: var(--rt-text);\n  line-height: 1.25;\n}\n\n.rt-page-header__title-row {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  min-width: 0;\n}\n\n.rt-page-header__back {\n  flex: 0 0 auto;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  height: 32px;\n  padding: 0 12px;\n  border: 1px solid var(--rt-border);\n  border-radius: var(--rt-radius-md, 8px);\n  background: var(--rt-surface);\n  color: var(--rt-text);\n  font-size: 13px;\n  font-weight: 600;\n  white-space: nowrap;\n  line-height: 1;\n  cursor: pointer;\n  transition: background 150ms ease, border-color 150ms ease;\n}\n\n.rt-page-header__back:hover {\n  background: var(--surface-hover, var(--rt-surface));\n  border-color: var(--rt-primary);\n  color: var(--rt-primary);\n}\n\n.rt-page-header__back:focus-visible {\n  outline: none;\n  box-shadow: var(--shadow-focus, 0 0 0 3px rgba(37, 99, 235, 0.35));\n}\n\n.rt-page-header__desc {\n  margin: 4px 0 0;\n  font-size: var(--rt-text-sm);\n  color: var(--rt-text-muted);\n  max-width: 64ch;\n}\n\n.rt-page-header__actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  align-items: center;\n}\n\n.rt-section-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  margin-bottom: 10px;\n}\n\n.rt-section-header__title {\n  margin: 0;\n  font-size: var(--rt-text-sm);\n  font-weight: 650;\n}\n\n.rt-breadcrumbs {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 6px;\n  margin-bottom: 2px;\n  font-size: var(--rt-text-xs);\n  color: var(--rt-text-muted);\n}\n\n.rt-breadcrumbs__sep {\n  opacity: 0.5;\n}\n\n.rt-breadcrumbs__link {\n  background: none;\n  border: none;\n  padding: 0;\n  color: var(--rt-primary);\n  font: inherit;\n  cursor: pointer;\n}\n\n.rt-breadcrumbs__link:hover {\n  text-decoration: underline;\n}\n\n.rt-breadcrumbs__current {\n  color: var(--rt-text-secondary);\n  font-weight: 600;\n}\n\n.rt-filter-bar {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  align-items: center;\n  padding: 10px 12px;\n  background: var(--rt-surface);\n  border: 1px solid var(--rt-border);\n  border-radius: var(--rt-radius-lg);\n}\n\n.rt-search {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  height: 32px;\n  min-width: 220px;\n  padding: 0 10px;\n  border: 1px solid var(--rt-border);\n  border-radius: var(--rt-radius-md);\n  background: var(--rt-bg);\n}\n\n.rt-search input {\n  flex: 1;\n  border: none;\n  background: transparent;\n  outline: none;\n  font: inherit;\n  font-size: var(--rt-text-sm);\n  color: var(--rt-text);\n  min-width: 0;\n}\n\n.rt-tabs {\n  display: flex;\n  gap: 2px;\n  border-bottom: 1px solid var(--rt-border);\n  overflow-x: auto;\n  overflow-y: hidden;\n  scrollbar-width: none;\n}\n\n.rt-tabs::-webkit-scrollbar {\n  display: none;\n}\n\n.rt-tabs__tab {\n  appearance: none;\n  border: none;\n  background: transparent;\n  padding: 10px 14px;\n  font: inherit;\n  font-size: var(--rt-text-sm);\n  font-weight: 550;\n  color: var(--rt-text-muted);\n  cursor: pointer;\n  border-bottom: 2px solid transparent;\n  white-space: nowrap;\n}\n\n.rt-tabs__tab:hover {\n  color: var(--rt-text);\n}\n\n.rt-tabs__tab--active {\n  color: var(--rt-primary);\n  border-bottom-color: var(--rt-primary);\n  font-weight: 650;\n}\n\n.rt-data-table-wrap {\n  background: var(--rt-surface);\n  border: 1px solid var(--rt-border);\n  border-radius: var(--rt-radius-lg);\n  overflow: auto;\n}\n\n.rt-data-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: var(--rt-text-sm);\n}\n\n.rt-data-table th {\n  text-align: left;\n  font-size: 10px;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: var(--rt-text-muted);\n  font-weight: 650;\n  padding: 10px 12px;\n  border-bottom: 1px solid var(--rt-border);\n  background: var(--rt-surface-hover);\n  position: sticky;\n  top: 0;\n  z-index: 1;\n  white-space: nowrap;\n}\n\n.rt-data-table td {\n  padding: 10px 12px;\n  border-bottom: 1px solid var(--rt-border-subtle);\n  vertical-align: middle;\n}\n\n.rt-data-table tr:hover td {\n  background: var(--rt-surface-hover);\n}\n\n.rt-data-table tr.rt-data-table__row--clickable {\n  cursor: pointer;\n}\n\n.rt-bulk-bar {\n  position: sticky;\n  bottom: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 10px 14px;\n  background: #0f172a;\n  color: #fff;\n  border: 1px solid transparent;\n  border-radius: var(--rt-radius-lg);\n  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.2);\n  z-index: 20;\n}\n\n.rt-bulk-bar__actions {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.rt-bulk-bar > span {\n  font-weight: 600;\n}\n\n.rt-bulk-bar .rt-btn--secondary {\n  background: transparent;\n  color: #fff;\n  border-color: rgba(255, 255, 255, 0.35);\n}\n\n.rt-bulk-bar .rt-btn--secondary:hover:not(:disabled) {\n  background: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme='dark'] .rt-bulk-bar {\n  background: var(--surface-raised, #0f1b2e);\n  color: var(--text-primary);\n  border-color: color-mix(in srgb, var(--primary) 55%, transparent);\n  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.45);\n}\n\n[data-theme='dark'] .rt-bulk-bar .rt-btn--secondary {\n  color: var(--text-primary);\n  border-color: var(--border-strong, var(--border));\n}\n\n[data-theme='dark'] .rt-bulk-bar .rt-btn--secondary:hover:not(:disabled) {\n  background: var(--surface-hover);\n}\n\n.rt-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 48px 20px;\n  text-align: center;\n  background: var(--rt-surface);\n  border: 1px dashed var(--rt-border);\n  border-radius: var(--rt-radius-lg);\n  color: var(--rt-text-muted);\n}\n\n.rt-state__title {\n  margin: 0;\n  font-size: var(--rt-text-base);\n  font-weight: 650;\n  color: var(--rt-text);\n}\n\n.rt-state__desc {\n  margin: 0;\n  font-size: var(--rt-text-sm);\n  max-width: 42ch;\n}\n\n.rt-drawer-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(15, 23, 42, 0.35);\n  z-index: 80;\n  display: flex;\n  justify-content: flex-end;\n}\n\n.rt-drawer {\n  width: min(480px, 100vw);\n  height: 100%;\n  background: var(--rt-surface);\n  border-left: 1px solid var(--rt-border);\n  display: flex;\n  flex-direction: column;\n  box-shadow: -12px 0 40px rgba(15, 23, 42, 0.12);\n}\n\n.rt-drawer--wide {\n  width: min(640px, 100vw);\n}\n\n.rt-drawer__header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 16px 18px;\n  border-bottom: 1px solid var(--rt-border);\n}\n\n.rt-drawer__title {\n  margin: 0;\n  font-size: 1rem;\n  font-weight: 700;\n}\n\n.rt-drawer__body {\n  flex: 1;\n  overflow: auto;\n  padding: 16px 18px;\n}\n\n.rt-drawer__footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n  padding: 12px 18px;\n  border-top: 1px solid var(--rt-border);\n  background: var(--rt-bg);\n}\n\n.rt-dialog-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(15, 23, 42, 0.4);\n  z-index: 90;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n}\n\n.rt-dialog {\n  width: min(420px, 100%);\n  background: var(--rt-surface);\n  border: 1px solid var(--rt-border);\n  border-radius: var(--rt-radius-lg);\n  box-shadow: 0 20px 50px rgba(15, 23, 42, 0.2);\n  padding: 18px;\n}\n\n.rt-dialog__title {\n  margin: 0 0 8px;\n  font-size: 1rem;\n  font-weight: 700;\n}\n\n.rt-dialog__body {\n  margin: 0 0 16px;\n  font-size: var(--rt-text-sm);\n  color: var(--rt-text-secondary);\n}\n\n.rt-dialog__actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n}\n\n.rt-metric-card {\n  background: var(--rt-surface);\n  border: 1px solid var(--rt-border);\n  border-radius: var(--rt-radius-lg);\n  padding: 12px 14px;\n}\n\n.rt-metric-card__label {\n  font-size: 0.6875rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: var(--rt-text-muted);\n}\n\n.rt-metric-card__value {\n  font-size: 1.625rem;\n  font-weight: 750;\n  letter-spacing: -0.03em;\n  font-variant-numeric: tabular-nums;\n}\n\n.rt-metric-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));\n  gap: 12px;\n}\n\n.rt-hub-layout {\n  display: grid;\n  grid-template-columns: 200px 1fr;\n  gap: 14px;\n  align-items: start;\n}\n\n.rt-hub-nav {\n  background: var(--rt-surface);\n  border: 1px solid var(--rt-border);\n  border-radius: var(--rt-radius-lg);\n  padding: 8px;\n  position: sticky;\n  top: 8px;\n}\n\n.rt-hub-nav__item {\n  display: flex;\n  width: 100%;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 10px;\n  border: none;\n  border-radius: var(--rt-radius-md);\n  background: transparent;\n  color: var(--rt-text-secondary);\n  font: inherit;\n  font-size: var(--rt-text-sm);\n  font-weight: 550;\n  text-align: left;\n  cursor: pointer;\n}\n\n.rt-hub-nav__item:hover {\n  background: var(--rt-bg);\n  color: var(--rt-text);\n}\n\n.rt-hub-nav__item--active {\n  background: var(--rt-primary-subtle);\n  color: var(--rt-primary);\n  font-weight: 650;\n}\n\n.rt-hub-content {\n  min-width: 0;\n}\n\n/* Settings hub: single section header + content panel (no nested duplicate titles) */\n.rt-settings-layout {\n  align-items: start;\n}\n\n.rt-settings-nav-group {\n  margin-bottom: 12px;\n}\n\n.rt-settings-nav-group:last-child {\n  margin-bottom: 0;\n}\n\n.rt-settings-nav-group__label {\n  padding: 4px 10px;\n}\n\n.rt-settings-section-header {\n  margin-bottom: 12px;\n}\n\n.rt-settings-section-header__title {\n  margin: 0 0 4px;\n  font-size: 1.05rem;\n  font-weight: 650;\n  color: var(--rt-text);\n  line-height: 1.3;\n}\n\n.rt-settings-section-header__description {\n  margin: 0;\n  font-size: var(--rt-text-sm, 0.875rem);\n  color: var(--rt-text-secondary);\n  line-height: 1.45;\n}\n\n.rt-settings-panel {\n  background: var(--rt-surface);\n  border: 1px solid var(--rt-border);\n  border-radius: var(--rt-radius-lg);\n  padding: 1.25rem 1.35rem;\n  min-width: 0;\n}\n\n.rt-settings-panel .settings-section {\n  margin-bottom: 0;\n}\n\n.rt-settings-panel .settings-section-title {\n  font-size: 1.35rem;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  line-height: 1.25;\n  margin-bottom: 0.35rem;\n  padding-bottom: 0;\n  border-bottom: none;\n}\n\n.rt-settings-panel .settings-section-intro {\n  margin-bottom: 1.15rem;\n  padding-bottom: 0.85rem;\n  border-bottom: 1px solid var(--rt-border-subtle, var(--rt-border));\n}\n\n.rt-settings-panel .settings-section-intro .settings-subtitle {\n  margin-bottom: 0 !important;\n}\n\n.rt-legacy-embed {\n  /* Soften legacy page chrome when nested in AppShell */\n}\n\n.rt-legacy-embed .settings-container,\n.rt-legacy-embed .test-cases-overview-container,\n.rt-legacy-embed .test-suites-container,\n.rt-legacy-embed .test-plans-container,\n.rt-legacy-embed .reports-container,\n.rt-legacy-embed .requirement-upload-page,\n.rt-legacy-embed .jira-items-container {\n  padding: 0 !important;\n  margin: 0 !important;\n  max-width: none !important;\n  background: transparent !important;\n  box-shadow: none !important;\n}\n\n.rt-detail-layout {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) 280px;\n  gap: 14px;\n  align-items: start;\n}\n\n.rt-detail-main,\n.rt-detail-side {\n  background: var(--rt-surface);\n  border: 1px solid var(--rt-border);\n  border-radius: var(--rt-radius-lg);\n  min-width: 0;\n}\n\n.rt-detail-main__body {\n  padding: 16px;\n}\n\n.rt-detail-side {\n  padding: 14px;\n  position: sticky;\n  top: 8px;\n}\n\n.rt-detail-meta {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.rt-detail-meta__row {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.rt-detail-meta__label {\n  font-size: 10px;\n  font-weight: 650;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: var(--rt-text-muted);\n}\n\n.rt-detail-meta__value {\n  font-size: var(--rt-text-sm);\n  color: var(--rt-text);\n  word-break: break-word;\n}\n\n@media (max-width: 960px) {\n  .rt-hub-layout,\n  .rt-detail-layout {\n    grid-template-columns: 1fr;\n  }\n\n  .rt-detail-side {\n    position: static;\n  }\n\n  .rt-hub-nav {\n    position: static;\n    display: flex;\n    flex-wrap: wrap;\n    gap: 4px;\n  }\n}\n\n.rt-page-header--slim {\n  margin-bottom: 4px;\n  padding-bottom: 8px;\n  border-bottom: 1px solid var(--rt-border-subtle);\n}\n\n.rt-page--compact .rt-page-header__title {\n  font-size: 1.15rem;\n}\n\n/* Hide nested legacy page titles when wrapped by RT2 PageScaffold */\n.rt-legacy-embed .report-title,\n.rt-legacy-embed .report-subtitle,\n.rt-legacy-embed .settings-header,\n.rt-legacy-embed .settings-title,\n.rt-legacy-embed .dashboard-welcome,\n.rt-legacy-embed .projects-title,\n.rt-legacy-embed .projects-subtitle,\n.rt-legacy-embed .epics-stories-header h1,\n.rt-legacy-embed .requirement-upload-page > h1 {\n  display: none !important;\n}\n\n.rt-entity-chrome-hidden {\n  display: none !important;\n}\n\n/* Global RT2 modal skin — highlighted header wash */\n.modal-header,\n.test-execution-modal .modal-header,\n.create-test-suite-modal .modal-header,\n.schedule-modal .modal-header,\n.sprint-modal .modal-header,\n.workspace-modal .modal-header,\n.rt-modal__header {\n  background-color: #eff6ff !important;\n  background-image:\n    linear-gradient(\n      135deg,\n      rgba(37, 99, 235, 0.14) 0%,\n      rgba(59, 130, 246, 0.1) 48%,\n      rgba(96, 165, 250, 0.08) 100%\n    ) !important;\n  color: #1e3a8a !important;\n  border-bottom: 1px solid rgba(37, 99, 235, 0.22);\n  border-radius: var(--rt-radius-lg, 16px) var(--rt-radius-lg, 16px) 0 0;\n  padding: 16px 20px;\n}\n\n.modal-header h2,\n.modal-header h3,\n.modal-header .modal-title,\n.test-execution-modal .modal-header h2,\n.schedule-modal .modal-header h2,\n.sprint-modal .modal-header h2,\n.workspace-modal .modal-header h2,\n.rt-modal__header h2,\n.rt-modal__title {\n  color: #1e3a8a !important;\n  font-size: 1.125rem;\n  font-weight: 700;\n  letter-spacing: -0.01em;\n  margin: 0;\n}\n\n.modal-header .modal-close,\n.modal-header .modal-close-btn,\n.modal-header .close-button,\n.modal-header button,\n.rt-modal__close {\n  color: #3b82f6 !important;\n}\n\n.modal-container,\n.test-execution-modal,\n.create-test-suite-modal,\n.schedule-modal,\n.sprint-modal,\n.workspace-modal {\n  border: 1px solid var(--rt-border, var(--border));\n  border-radius: var(--rt-radius-lg, 16px);\n  box-shadow: var(--modal-shadow, 0 24px 48px rgba(15, 23, 42, 0.2));\n}\n\n.modal-footer,\n.test-execution-modal .modal-footer,\n.schedule-modal .modal-footer,\n.workspace-modal .modal-footer {\n  background: transparent !important;\n  border-top: 1px solid var(--rt-border, var(--border));\n}\n\n.rt-plan-as-page {\n  position: static !important;\n  inset: auto !important;\n  background: transparent !important;\n  padding: 0 !important;\n  display: block !important;\n  z-index: auto !important;\n}\n\n.rt-plan-as-page > div {\n  width: 100% !important;\n  height: auto !important;\n  max-height: none !important;\n  box-shadow: none !important;\n  border: 1px solid var(--rt-border);\n  border-radius: var(--rt-radius-lg);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
